const enrichmentState = {
  activeEnrichment: null,
  nextEnrichment: null,
}

export default enrichmentState
